// @ts-ignore
import {createLogger} from 'redux-logger';
import {createPromise} from 'redux-promise-middleware';
import {Action} from "edocatbase/Global";
import { createStore, applyMiddleware, compose } from 'redux';

export default function configureStore(appReducer: any, initialState: any) {
  const logDeps = [window.reduxThunk];
  // ADDING ASYNC DISPATCHING FROM WITHIN REDUCER
  const asyncDispatchMiddleware = (store: any) => (next: any) => (action: Action) => {
    let syncActivityFinished = false;
    let actionQueue: Array<Action> = [];

    const flushQueue = () => {
      actionQueue.forEach(a => store.dispatch(a));
      actionQueue = [];
    }

    const asyncDispatch = (asyncAction: any) => {
      actionQueue = actionQueue.concat([asyncAction]);
      if (syncActivityFinished) {
        flushQueue();
      }
    }
    const actionWithAsyncDispatch =
      Object.assign({}, action, { asyncDispatch });
    const res = next(actionWithAsyncDispatch);
    syncActivityFinished = true;
    flushQueue();
    return res;
  };

  if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger();
    logDeps.push(logger);
  }

  const getCookieNumberValue = (key: string): number => {
    let cookieArr = document.cookie.split(";").map(prt => prt.trim());
    for (let cid in cookieArr) {
      let pair = cookieArr[cid].split('=').map(prt => decodeURIComponent(prt.trim()));
      if (pair?.[0] === key) return parseInt(pair?.[1]) ?? 3660000 /* if value is not valid number */;
    }
    return 3660000 /* if key not exist, 3660000 is 61 minutes for default 59 minute session timeout */;
  };

  const autoLogout = ({ getState }) => (next: any) => (action: any) => {
    clearTimeout(window.logoutTimeout);
    window.logoutTimeout = setTimeout(
      () => { window.location.reload() },
      getCookieNumberValue('edcSessionTimeout') + 120000 /* after some tests timeout prolong is needed */
    );
    return next(action);
  };

  const dispatchEventMiddleware = ({getState}) => next => action => {
    const state = getState();
    window.dispatchEvent(new CustomEvent('EVENT_REDUX_ACTION', {
      detail: {
        type: action?.type,
        payload: action?.payload,
        state,
      }
    }));
    window.__e_state__ = state;
    return next(action)
  };

  const middleware = [
    createPromise({
      promiseTypeSuffixes: ['START', 'SUCCESS', 'ERROR'],
    }),
    autoLogout,
    ...logDeps,
    asyncDispatchMiddleware,
    dispatchEventMiddleware,
  ];
  /*
    const createReduxStore = window.redux.applyMiddleware(...middleware);

    if (initialState) {
      return createReduxStore(window.redux.createStore)(appReducer, initialState);
    }

    return createReduxStore(window.redux.createStore)(appReducer);
    */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  if (initialState) {
    return createStore(appReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
  }
  return createStore(appReducer, undefined, composeEnhancers(applyMiddleware(...middleware)));
}
